module.exports = __webpack_public_path__ + "media/icons/pochodzenie-sprowadzony-blue@3x-257e20e4.svg";